import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { chatService } from "services/chatService";

const ChatsAdminContext = createContext();

export const ChatsAdminProvider = ({ children }) => {
  const pageSize = 10;

  const [sortBy, setSortBy] = useState("created_at_newest");
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fetchedChats, setFetchedChats] = useState([]);

  const fetchChats = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await chatService.getAllChatsAdmin(
        pageSize,
        pageNumber,
        sortBy,
        searchQuery
      );
      setFetchedChats(response.chats);
      setNumberOfPages(response.totalPages);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChats();
  }, [pageNumber, sortBy, searchQuery]);

  useEffect(() => {
    fetchChats();
  }, []);

  return (
    <ChatsAdminContext.Provider
      value={{
        fetchedChats,
        loading,
        error,
        pageSize,
        sortBy,
        setSortBy,
        searchQuery,
        setSearchQuery,
        pageNumber,
        setPageNumber,
        numberOfPages,
        setNumberOfPages,
      }}
    >
      {children}
    </ChatsAdminContext.Provider>
  );
};

ChatsAdminProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useChatsAdmin = () => useContext(ChatsAdminContext);
